module.exports = __webpack_public_path__ + "static/job_posting.e1c31d2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/index/assets/2x/job_posting.jpg
// module id = 363
// module chunks = 35783957827783